module.exports = __webpack_public_path__ + "static/media/img_prn50.b5602b9a.png";